import { DesktopWrapper, MobileWrapper } from '@lmc/ui-kit'
import styled from 'styled-components'

type FilterContainerProps = {
  children: JSX.Element
  title: string
}

export const FilterContainer = ({
  children,
  title,
}: FilterContainerProps): JSX.Element => (
  <StyledFilterContainer>
    <DesktopWrapper>{children}</DesktopWrapper>
    <MobileWrapper title={title}>{children}</MobileWrapper>
  </StyledFilterContainer>
)

const StyledFilterContainer = styled.div`
  .ant-select-selection-placeholder,
  .ant-picker-input > input::placeholder {
    color: ${(props) => props.theme.color.neutral.color4};
  }
`

export default FilterContainer
